export enum TriStateEnum {
  OFF = 'off',
  ON = 'on',
  FULL = 'full',
}
